import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const { breakpoints, colors } = constants;
const { md } = breakpoints.BreakpointNames;
const { textLObj } = typographyStyles;

export const errorPanelCss = {
  marginTop: "48px",
  marginBottom: "24px",

  [mediaQuery.upTo(md)]: {
    maxWidth: "none",
    padding: "0 80px",
  },
  a: {
    paddingLeft: "16px",
    paddingRight: "16px",
    width: "auto",
  },
};
export const messageCss = {
  ...textLObj,
  marginBottom: "56px",
};

export const headlineCss = {
  color: colors.ui.neutral[600],
};
